import { useAuth } from '../auth';

/**
 * Custom hook to check if the current user is a system admin
 * @returns boolean indicating if the current user is a system admin
 */
export const useIsSystemAdmin = () => {
  const { user } = useAuth();
  return user?.is_admin ?? false;
};
